import { SelectOption } from '../../types'
import nationalities from '../nationalities'

export const transformNationalityToSelectOption = (nationality: string): SelectOption => (nationalities
    .find(option => option.value === nationality)
    || nationalities.find(option => option.value === 'NL')) as SelectOption
